import type {
  ProblemScoringForViewOption,
  ProblemScoringViewOption,
} from '../../../@trait/ProblemScoringViewOption.trait'

type ViewOption = ProblemScoringViewOption<'학습모듈' | 'NOT_학습모듈'>

/**
 * Drawer 내부 "해설" 섹션 실제 렌더 조건 (정답해설 섹션 공개).
 * - 학부모: 학부모정답해설공개(=채점후정답해설공개) 단독 시그널, 학생 제출 무관
 * - 자기주도학습: 채점후정답해설공개 플래그 무시하고 제출 후 공개
 * - 학생: 제출 후에만 채점후정답해설공개 따름
 */
export const isSolutionSectionOpen = (
  viewOption: ViewOption,
  problemScoring: ProblemScoringForViewOption,
) => {
  if (viewOption.isParentView) return !!viewOption.studentAppSetting?.채점후정답해설공개
  return (
    problemScoring.isSubmitted &&
    (viewOption.isSelfLearning || !!viewOption.studentAppSetting?.채점후정답해설공개)
  )
}

/**
 * Drawer 내부 "풀이동영상" 섹션 실제 렌더 조건 (문풀동 섹션 공개).
 * - 자기주도학습은 항상 공개
 */
export const isProblemVideoSectionOpen = (
  viewOption: ViewOption,
  problemScoring: ProblemScoringForViewOption,
) => {
  const studentAppSetting = viewOption.studentAppSetting
  if (!studentAppSetting) return true
  return (
    (!problemScoring.isSubmitted && studentAppSetting.채점전문풀동공개) ||
    (problemScoring.isSubmitted && studentAppSetting.채점후문풀동공개)
  )
}
